import { useState } from 'react';
import appConstants from '../../constants';

const FEATURE_PARTNER_SEARCH = 'partner search';
const FEATURE_PARTNER_COMPARATOR = 'partner comparator';

const constants = Object.freeze({
  FEATURE_PARTNER_SEARCH: FEATURE_PARTNER_SEARCH,
  FEATURE_PARTNER_COMPARATOR: FEATURE_PARTNER_COMPARATOR,
  FEATURES: [FEATURE_PARTNER_COMPARATOR, FEATURE_PARTNER_SEARCH],
  FEATURE_SELECTION_DEFAULT: FEATURE_PARTNER_SEARCH
});

const defaults = Object.freeze( {
  initialFeatureSelection: constants.FEATURE_SELECTION_DEFAULT
});

export default function usePartnerFeatureNavigation() {

  const [selectedFeature, setSelectedFeature] = useState(defaults.initialFeatureSelection);

  function selectPartnerFeature(feature) {
    if (constants.FEATURES.includes(feature)) {
      setSelectedFeature((selectedFeature) => feature);
    }
    else {
      appConstants.APP_DEBUG_LOGGER(`Invalid feature: ${feature}`);
    }
  }

  function isFeatureSelected(feature) {
    return feature === selectedFeature;
  }

  function selectPartnerSearchFeature() {
    selectPartnerFeature(constants.FEATURE_PARTNER_SEARCH);
  }

  function selectPartnerComparatorFeature() {
    selectPartnerFeature(constants.FEATURE_PARTNER_COMPARATOR);
  }

  function isPartnerSearchFeatureSelected() {
    return isFeatureSelected(constants.FEATURE_PARTNER_SEARCH);
  }

  function isPartnerComparatorFeatureSelected() {
    return isFeatureSelected(constants.FEATURE_PARTNER_COMPARATOR);
  }

  function getSelectedPartnerFeature() {
    return selectedFeature;
  }

  return {
    selectPartnerSearchFeature,
    selectPartnerComparatorFeature,
    isPartnerSearchFeatureSelected,
    isPartnerComparatorFeatureSelected,

    selectPartnerFeature,
    getSelectedPartnerFeature
  }
}
